<div class="home" >
  <div class="texto">
    
  </div>
  <div class="login">
    <a href="https://xtensa.es/"><img src="./../../../assets/logo-xtensa.png"/></a>
    <p>Bienvenido</p>

    <div *ngIf="invalidUser" class="invalidUser">
      El usuario o la contraseña son incorrectos.
    </div>
    
    <form class="form" [formGroup]="datosUser">
      <mat-form-field appearance="outline">
        <mat-label>Usuario</mat-label>
        <input matInput placeholder="Usuario" formControlName="user" required/>
      </mat-form-field>

      <mat-form-field appearance="outline" class="">
        <mat-label>Contraseña</mat-label>
        <input matInput placeholder="Contraseña" [type]="hide ? 'password' : 'text'" formControlName="password" required autocomplete="on">
      <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </mat-form-field>
      <div class="contraseña">
        
        <a  [routerLink]="['/resetPassword']" routerLinkActive="router-link-active" >¿Olvidaste tu Contraseña?</a>
      </div>
      <button class="primary-button" (click)="handleLogin()">
        Entrar
      </button>
    </form>
    <!-- <p class="registrarte">
      ¿Aún no eres miembro? Registrate ahora Selecciona una de estas opciones:
    </p>
    <div class="botones-plan">
      
      <button class="secondary-button" [routerLink]="['/xtensaBasica']">Xtensa Básica</button>
      <button class="secondary-button" [routerLink]="['xtensa-ampliada']">Xtensa Ampliada</button>
    </div> -->
  </div>
</div>
